export default "__VITE_ASSET__C7xiEKrd__"